
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/africa/agenda",
      function () {
        return require("private-next-pages/africa/agenda.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/africa/agenda"])
      });
    }
  